import React from "react";
import Navbar from "../organisms/navbar.tsx";

export default function Header() {
  return (
    <React.Fragment>
      <Navbar />
    </React.Fragment>
  );
}
